document.addEventListener("DOMContentLoaded", () => {
    const carousels = document.querySelectorAll(".product-carousel");
    const breakpoint = 768; // Screen width breakpoint in pixels
    let itemsPerPage = window.innerWidth < breakpoint ? 2 : 4;
  
    const updateItemsPerPage = () => {
      itemsPerPage = window.innerWidth < breakpoint ? 2 : 4;
    };
  
    const setupCarousel = (carousel) => {
      const inner = carousel.querySelector(".product-carousel-inner");
      const prevBtn = carousel.querySelector(".prev");
      const nextBtn = carousel.querySelector(".next");
      const indicatorWrapper = carousel.querySelector(".indicator-wrapper");
      const items = Array.from(inner.querySelectorAll(".card-wrapper"));
      const indicatorContainer = document.createElement("div");
      indicatorContainer.className = "caro-indicators";
      indicatorWrapper.appendChild(indicatorContainer);
  
      let currentPage = 0;
  
      const updateIndicators = () => {
        const pageCount = Math.ceil(items.length / itemsPerPage);
        indicatorContainer.innerHTML = ""; // Clear previous indicators
  
        for (let i = 0; i < pageCount; i++) {
          const dot = document.createElement("div");
          dot.className = "caro-indicator";
          if (i === currentPage) dot.classList.add("caro-indicator-active");
          dot.addEventListener("click", () => {
            currentPage = i;
            updateCarouselPosition();
            updateIndicators();
          });
          indicatorContainer.appendChild(dot);
        }
      };
  
      const updateCarouselItems = () => {
        // Clear extra items added during auto-fill
        const extraItems = inner.querySelectorAll(".card-wrapper.extra");
        extraItems.forEach(item => item.remove());
  
        // Adjust items and auto-fill last page
        const totalItems = items.length;
        const remainder = totalItems % itemsPerPage;
        if (remainder !== 0) {
          const fillerCount = itemsPerPage - remainder;
          for (let i = 0; i < fillerCount; i++) {
            const clone = items[i % totalItems].cloneNode(true);
            clone.classList.add("extra");
            inner.appendChild(clone);
          }
        }
  
        updateIndicators(); // Update indicators after adjusting items
      };
  
      const updateCarouselPosition = () => {
        const offset = currentPage * -100;
        inner.style.transform = `translateX(${offset}%)`;
        updateIndicators();
      };
  
      // Navigation buttons
      prevBtn.addEventListener("click", () => {
        const pageCount = Math.ceil(items.length / itemsPerPage);
        currentPage = (currentPage - 1 + pageCount) % pageCount;
        updateCarouselPosition();
      });
  
      nextBtn.addEventListener("click", () => {
        const pageCount = Math.ceil(items.length / itemsPerPage);
        currentPage = (currentPage + 1) % pageCount;
        updateCarouselPosition();
      });
  
      // Recalculate on resize
      const handleResize = () => {
        updateItemsPerPage();
        updateCarouselItems();
        currentPage = 0; // Reset to the first page
        updateCarouselPosition();
      };
  
      // Set up initial items
      updateCarouselItems();
  
      // Attach resize event listener
      window.addEventListener("resize", handleResize);
    };
  
    carousels.forEach(setupCarousel);
  });    